import React from 'react'
import { Subheader } from '../../Page/logix2020/Subheader'
import { useTranslation } from 'react-i18next'
import { GoBackBtn } from '../../Buttons/GoBackBtn'

const EditReceiptSubheader = () => {
  const { t } = useTranslation()

  return (
    <Subheader className="subHeader-v1">
      <div className="flex-grow-1">
        <div>
          <GoBackBtn color="white" to="/localstorage/goodsreceipts">
            {t('goodsReceiptPage:overviewGoodsReceipt')}
          </GoBackBtn>
          <div className="subheader-title-small">{t('goodsReceiptPage:editGoodsReceipt')} </div>
        </div>
      </div>
    </Subheader>
  )
}

export default EditReceiptSubheader